import { useBenchmarkReport } from "./benchmarkApi/useBenchmarkReport"
import AboutSection from "./about/AboutSection"
import BenchmarkSearchSection from "./benchmarkSearch/BenchmarkSearchSection"
import CalculatorSection from "./calculator/CalculatorSection"
import CaseStudySection from "./caseStudy/CaseStudySection"
import QuoteSection from "./caseStudy/QuoteSection"
import CredibilitySection from "./credibility/CredibilitySection"
import DecaySection from "./decay/DecaySection"
import FindingsSection from "./findings/FindingsSection"
import FinalConverterSection from "./finalConverter/FinalConverterSection"
import LightFooter from "./footer/LightFooter"
import LightHeader from "./header/LightHeader"
import LeadInterceptionSection from "./leadInterception/LeadInterceptionSection"
import LeaderboardSection from "./leaderboard/LeaderboardSection"
import LiveProofSection from "./liveProof/LiveProofSection"
import MethodologySection from "./methodology/MethodologySection"
import NotForSection from "./notFor/NotForSection"
import SundayGapSection from "./sundayGap/SundayGapSection"
import { contentColumnClass, pageRootClass } from "./lightTheme"

export default function RoofingSpeedToLeadBenchmarkLanding() {
  const report = useBenchmarkReport()

  return (
    <div className="roofing-light-canvas min-h-screen w-full bg-[#FAFAFA]">
      <LightHeader />
      <div className={`${pageRootClass} pt-0`}>
        <div className={contentColumnClass}>
          <CredibilitySection stats={report.stats} statsStatus={report.statsStatus} />
          <MethodologySection
            statsStatus={report.statsStatus}
            totalCompanies={report.stats?.total_companies}
          />
          <BenchmarkSearchSection
            statsStatus={report.statsStatus}
            totalCompanies={report.stats?.total_companies}
          />
          <LeaderboardSection countries={report.countries} />
          <FindingsSection />
          <DecaySection />
          <SundayGapSection />
          <CalculatorSection />
          <AboutSection statsStatus={report.statsStatus} totalCompanies={report.stats?.total_companies} />
          <LiveProofSection />
          <CaseStudySection />
          <QuoteSection />
          <NotForSection />
          <LeadInterceptionSection />
          <FinalConverterSection stats={report.stats} statsStatus={report.statsStatus} />
        </div>
        <LightFooter />
      </div>
    </div>
  )
}
